import React, { useEffect } from 'react';
import { useLocation } from 'react-router';

// Util import
import {
    defaultPanelFilters,
    maisCarrinhoFilters,
} from '~/util/ordersPanelArrays';
import {
    applyOrdersFilter,
    applySearchFitler,
    applyBrandFilter,
    getListByFilter,
    getCartsListByFilter,
    getTotalValue,
} from '~/util/orderPanelFunctions';

import * as Style from './styles';

function FilterButtons({
    orders,
    setFilteredOrders,
    filter,
    setFilter,
    ordersFilter,
    setOrdersFilter,
    setHideOrdersFilter,
    setTotalFilterValue,
    searchFilter,
    filteredOrders,
    brandFilter,
}) {
    const location = useLocation().pathname;

    const getFiltersList = () => {
        if (location === '/storeOmni') return defaultPanelFilters.slice(0, 3);
        if (location === '/maisCarrinho') return maisCarrinhoFilters;
        return defaultPanelFilters;
    };

    const filtersList = getFiltersList();

    const getFilterQuantity = filterName => {
        let getFilteredList;
        if (location === '/maisCarrinho') {
            getFilteredList = getCartsListByFilter(orders, filterName);
        } else {
            getFilteredList = getListByFilter(filteredOrders, filterName);
        }
        return getFilteredList?.length;
    };

    const handleClick = filterName => {
        let filteredList = orders;

        if (location === '/maisCarrinho') {
            const getNewCartsList = getCartsListByFilter(orders, filterName);
            setFilteredOrders(getNewCartsList);
            setFilter(filterName);
            return;
        }

        if (
            filterName !== 'Todos' &&
            filterName !== 'Vendas' &&
            ordersFilter !== 'allOrders'
        ) {
            setOrdersFilter('allOrders');
        }

        if (!['Todos', 'Vendas'].includes(filterName)) {
            setHideOrdersFilter(true);
        } else {
            setHideOrdersFilter(false);
        }

        filteredList = getListByFilter(filteredList, filterName);

        if (ordersFilter && ordersFilter !== 'allOrders') {
            filteredList = applyOrdersFilter(filteredList, ordersFilter);
        }

        if (searchFilter) {
            filteredList = applySearchFitler(filteredList, searchFilter);
        }

        filteredList = applyBrandFilter(filteredList, brandFilter);

        setFilter(filterName);
        setFilteredOrders(filteredList);
        setTotalFilterValue(getTotalValue(filteredList, filterName));
    };

    useEffect(() => {
        if (!orders || orders.length === 0) return;

        let filteredList = orders;

        filteredList = getListByFilter(filteredList, filter);

        if (ordersFilter && ordersFilter !== 'allOrders') {
            filteredList = applyOrdersFilter(filteredList, ordersFilter);
        }

        if (searchFilter) {
            filteredList = applySearchFitler(filteredList, searchFilter);
        }

        filteredList = applyBrandFilter(filteredList, brandFilter);

        setFilteredOrders(filteredList);
        setTotalFilterValue(getTotalValue(filteredList, ordersFilter));
    }, [
        orders,
        filter,
        ordersFilter,
        searchFilter,
        brandFilter,
        setFilteredOrders,
        setTotalFilterValue,
    ]);

    return (
        <Style.PillsFilterContainer>
            {filtersList.map(filterName => (
                <Style.StyledButtonPill
                    key={`pill-filter-${filterName} `}
                    primary={filterName === filter}
                    variant={filterName === filter ? 'contained' : 'outlined'}
                    size="medium"
                    onClick={() => {
                        handleClick(filterName);
                    }}
                >
                    {getFilterQuantity(filterName) !== undefined
                        ? `${filterName} (${getFilterQuantity(filterName)})`
                        : filterName}
                </Style.StyledButtonPill>
            ))}
        </Style.PillsFilterContainer>
    );
}

export default FilterButtons;
